define([
	'internal_util/Logger',
	'internal_util/Util',
	'model/CloudIdentity',
	'model/Attribute',
	'model/Origin',
	'model/bindings/PasswordBindingType',
	
	'factory/BindingsFactory'
], function (
		Logger,
		Util,
		CloudIdentity,
		Attribute,
		Origin,
		PasswordBindingType,
		
		BindingsFactory
		) {
	'use strict';

	/**
	 * CloudIdentityFactory class
	 */
	return new function () {

		// private methods
		
		function getCloudIdentityHeader(cloudIdentityString) {
			return JSON.parse(Util.base64Decode(cloudIdentityString.split('.')[1]));
		}

		function createCloudIdentity(cloudIdentityString, bindings, salt, enabled) {
			var info,
					header = getCloudIdentityHeader(cloudIdentityString);

			if (header['encrypted-payload'].hasOwnProperty('info')) {
				info = header['encrypted-payload']['info'];
			} else {
				throw new Error('invalid CloudID missing encrypted-payload.info: ' + header['encrypted-payload']);
			}

			return new CloudIdentity(
					header['jti'],
					cloudIdentityString,
					header.hasOwnProperty('iss') ? header['iss'] : null,
					header['iat'],
					header['exp'],
					createAttributes(info),
					bindings,
//					createBindings(info), //TODO: return binding model
					header['id-type'],
					salt,
					enabled);
		}

		function createAttributes(info) {
			var attr,
					origin,
					attrObj = Array();

			if (info.hasOwnProperty('attributes')) {
				attr = info['attributes'];
			} else {
				throw new Error('invalid CloudID missing encrypted-payload.info.attributes: ' + info);
			}

			if (! Util.isArray(attr)) {
				throw new Error('invalid CloudID encrypted-payload.info.attributes not an Array: ' + attr);
			}

			for (var i = 0; i < attr.length; i++) {
				origin = null;
				if (attr[i].hasOwnProperty('origin')) {
					origin = new Origin(attr[i]['origin'].typ,
							attr[i]['origin'].prt,
							attr[i]['origin'].iss);
				}
				attrObj.push(new Attribute(attr[i].name,
						null,
						origin));
			}
			return attrObj;
		}

		/**
		 * Check that the given object is a valid representation of a CloudID in local storage.
		 * This method may also perform an upgrade of the local storage object.
		 * 
		 * @param {Object} cloudIdentityObject
		 * @returns {undefined}
		 */
		function checkCloudIdentity(cloudIdentityObject) {
			if (! Util.isValidString(cloudIdentityObject['cloudIdentity'])) {
				throw new Error("Bad CloudID object missing or invalid 'cloudIdentity'");
			}
			
			var header = getCloudIdentityHeader(cloudIdentityObject['cloudIdentity']);

			if (! header.hasOwnProperty('id-type')) {
				// if id-type is missing, then this CloudID is not version 2.0
				throw new Error("CloudID version 1.0 not supported anymore");
			}

			switch (header['id-type']) {
				// supported types:
				case "http://ws.skidentity.de/ci/v2.0":
					break;
				default:
					throw new Error("CloudID not supported 'id-type': " + header['id-type']);
			}

			if (cloudIdentityObject.hasOwnProperty("salt") && !cloudIdentityObject.hasOwnProperty("bindings")) {
			    throw new Error("Old CID!");
			}

			if (!cloudIdentityObject.hasOwnProperty('enabled') || typeof cloudIdentityObject['enabled'] !== 'boolean') {
				cloudIdentityObject['enabled'] = true;
			}
		}


		// public methods

		/**
		 * Create CloudIdentity object from given raw CloudID (JWT).
		 * 
		 * @param {string} cloudIdentityString Raw, base64 encoded CloudID (JWT).
		 * @param {BindingType} binding
		 * @returns {CloudIdentity} Created CloudIdentity object.
		 */
		this.create = function (cloudIdentityString, binding, salt) {
			var b = new Array();
			if (binding !== null) {
				if (!Util.isArray(binding)) {
					b.push(binding);
					binding = b;
				}
			}
			return createCloudIdentity(cloudIdentityString, binding, salt, true);
		};

		/**
		 * Create CloudIdentity object from CloudID Object stored in local storage.
		 * 
		 * @param {Object} cloudIdentityObject CloudID Object stored in local storage.
		 * @returns {CloudIdentity} Created CloudIdentity object.
		 */
		this.createFromObject = function (cloudIdentityObject) {
			var cloudIdentity;

			//Migration
			checkCloudIdentity(cloudIdentityObject);

			cloudIdentity = createCloudIdentity(
				cloudIdentityObject['cloudIdentity'],
				BindingsFactory.createFromObject(cloudIdentityObject['bindings']),
				cloudIdentityObject['salt'],
				cloudIdentityObject['enabled']);

			return cloudIdentity;
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/CloudIdentityFactory.js
// module id = 35
// module chunks = 8